import axios from 'axios';

export default () => axios({
  url: `${process.env.REACT_APP_MMB_API_URL}/api/config/tracking/`,
}).then(({ data }) => data.tracking_code).catch(() => '');
